import React, { useRef, useEffect } from 'react';
import { ChatMessage } from '../../model';
import './ChatContainer.scss';

export interface ChatContainerProps {
  messages: ChatMessage[];
  isNewMessage: boolean;
}

const ChatContainer: React.FC<ChatContainerProps> = ({
  messages,
  isNewMessage,
}) => {
  const chatContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className={`chat-container ${isNewMessage ? 'new-message' : ''}`}>
      <div className="chat-messages" ref={chatContainerRef}>
        {messages?.map(message => (
          <div
            key={message.uuid}
            className={`message ${message.senderType === 'HUMAN' ? 'right' : 'left'} ${
              message.senderType === 'AGENT' ? 'agent' : ''
            }`}>
            <div className="message-body">{message.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatContainer;
